/**
 * Created by bcole on 10/11/17.
 */
import React from 'react'

export default class IconStats extends React.Component {

    render() {

        return (
            <svg id="icon-stats" viewBox="0 0 32 32" fill="currentColor" className={this.props.className}>
                <title>stats</title>
                <path d="M6.987 5h-0.987v23h20v-0.963l-18.996-0.050-0.017-21.987zM14 13.812l-5-5v16.188h5v-11.188zM15 13.125v11.875h5v-12.875l-2-2-3 3zM21 16v9h5v-9h-5zM18.119 7.371l5.242 5.259-1.467 1.39 4.103 0.044-0.019-3.961-1.771 1.719-6.086-6.175-3.745 3.787-4.317-4.314-0.877 0.911 5.123 5.168 3.814-3.828z"></path>
            </svg>
        )
    }
}